import '@fortawesome/fontawesome-free/css/all.css';
import '@elotech/arc/src/assets/less/compiled/protocolo.css';

import './icons/IconsLibrary';

import { StorageService } from 'libs';
import ReactDOM from 'react-dom';
import { ProcessoExternoService, ProtocoloConfigService } from 'service';
import { configureIntl, getEntidadeByPathname } from 'utils';

import App from './App';

configureIntl();

const getConfigs = () => {
  const entidade = getEntidadeByPathname();
  return Promise.all([
    ProtocoloConfigService.getConfig(entidade),
    ProcessoExternoService.getConfig(entidade)
  ]);
};

const renderApp = (config, configExterna) => {
  ReactDOM.render(
    <App config={config} configExterna={configExterna} />,
    document.getElementById('root')
  );
};

const config = StorageService.getItem('config');
const configExterna = StorageService.getItem('configExterna');

if (config && configExterna) {
  renderApp(config, configExterna);
} else {
  getConfigs().then(([config, configExterna]) => {
    StorageService.saveItemAsJson('config', config.data);
    StorageService.saveItemAsJson('configExterna', configExterna.data);
    renderApp(config.data, configExterna.data);
  });
}
